import type { ConfigApi, OAuthApi } from '@backstage/core-plugin-api';
import type { ArmAssertionSupplier } from '@ns/plugin-arm-proxy-client';

/**
 * Derives the assertion supplier from the frontend-visible OBO client id.
 *
 * @param apis - The configuration and the Microsoft auth API of the app.
 * @returns A supplier that asks for `api://<clientId>/access_as_user`, or
 * `null` when `microsoftApis.obo.clientId` is not configured.
 * @throws When `microsoftApis.obo.clientId` is configured but blank.
 */
export function armAssertionSupplier(apis: {
  configApi: Pick<ConfigApi, 'getOptionalString'>;
  microsoftAuthApi: Pick<OAuthApi, 'getAccessToken'>;
}): ArmAssertionSupplier {
  const clientId = apis.configApi.getOptionalString(
    'microsoftApis.obo.clientId',
  );
  if (clientId === undefined) return null;
  if (clientId.trim() === '') {
    throw new Error('microsoftApis.obo.clientId is configured but empty');
  }
  const scope = `api://${clientId}/access_as_user`;
  return () => apis.microsoftAuthApi.getAccessToken(scope, { optional: false });
}
